/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCameraFront: {
  name: 'camera-front';
  data: string;
} = {
  name: 'camera-front',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5A1.5 1.5 0 0 0 1.5 2v8A1.5 1.5 0 0 0 3 11.5h10a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 13 .5H3ZM2.5 2a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V2ZM10 13.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm-4.354-.854a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1 0 .708l-1 1a.5.5 0 0 1-.708-.708l.147-.146H2a.5.5 0 0 1 0-1h3.793l-.147-.146a.5.5 0 0 1 0-.708ZM6.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" fill="currentColor"/></svg>`,
};
